import React from 'react'

interface PageHeaderProps {
  title: string
  action?: React.ReactNode
  className?: string
}

export default function PageHeader({ title, action, className = '' }: PageHeaderProps) {
  return (
    <div className={`bg-white dark:bg-gray-900 sticky top-0 z-10 ${className}`}>
      <div className="px-4 py-4 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
        {action && action}
      </div>
    </div>
  )
} 